import { Form, Formik } from 'formik';

import styled from '@emotion/styled';

interface IFormComponent {
  initialValues: any;
  schema: any;
  onSubmit: any;
  children: any;
  className?: any;
  autoComplete?: string;
}

export const FormComponent: React.FC<IFormComponent> = ({
  initialValues,
  schema,
  onSubmit,
  children,
  className,
  autoComplete = 'on',
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      <StyledForm className={className} autoComplete={autoComplete}>
        {children}
      </StyledForm>
    </Formik>
  );
};

const StyledForm = styled(Form)`
  width: 100%;
  display: grid;
  gap: 24px;
  /* border: 2px solid red; */

  &.inline,
  &.smaller-inline {
    grid-template-columns: 517px auto;

    & > button {
      margin-top: 31px;
      width: fit-content;
    }
  }

  &.inline-responsive {
    @media (max-width: 884px) {
      grid-template-columns: 1fr;
      gap: 0px;
      & > button {
        margin-top: 31px;
        width: 100%;
      }
      /* border: 2px solid red; */
    }
  }

  &.smaller-inline {
    grid-template-columns: 460px auto;

    @media (max-width: 884px) {
      & > button {
        width: 100%;
      }

      gap: 20px;
      grid-template-columns: auto 106px;
    }

    @media (max-width: 320px) {
      gap: 12px;
      grid-template-columns: auto 78px;
    }
  }

  &.small-gap {
    gap: 12px;

    & > * > * input {
      border: 1px solid #d2d5da;
    }
  }
`;
